import { GeneralShape } from '../general/general-shape';
import { ShapeService } from '../../shape.service';
import { ResourceData } from '../../../../elements/resource/resource.types';
import {
  GeneralShapeDescriptor,
  ShapeConfig,
} from '../../../../elements/resource/types/shape.type';

export class PlaceholderShape<
  DescriptorType extends GeneralShapeDescriptor = GeneralShapeDescriptor,
  C extends ShapeConfig = ShapeConfig,
> extends GeneralShape<DescriptorType, C> {
  constructor(
    service: ShapeService,
    resourceData: ResourceData<DescriptorType>,
    config?: C,
  ) {
    super(service, resourceData, config);
    this.init();
  }

  getType(): string {
    return 'placeholder-shape';
  }

  init(): void {
    super.init();
    // Additional placeholder-specific initialization can be added here
  }
}
